// shared/naming.js — Namensschema fuer neue Audio-Uploads (rename.md).
// Pure Functions, TDD-gedeckt. Liegt seit 2026-09-11 in shared/, weil auch
// das Frontend den Ziel-Dateinamen live vorausberechnet (Proben-Vormerkung) —
// eine zweite Kopie der Regeln waere eine Divergenz-Falle. Regeln: docs/tsd-uebergabe/rename.md.
import { FILE_MARKERS } from './voiceMeta.js';

const UMLAUTS = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'Ä': 'Ae', 'Ö': 'Oe', 'Ü': 'Ue', 'ß': 'ss' };

// Umlaute + Akzente → ASCII (OHNE finale Whitelist). Gemeinsame Basis für
// transliterate (Namen: nur A-Za-z0-9) UND sanitizeFreetextSuffix (zusätzlich _ + -).
// Reihenfolge kritisch: Umlaut-Ersetzung VOR NFD (sonst würde ä zu 'a' statt 'ae').
function foldToAscii(s) {
  let out = String(s ?? '');
  out = out.replace(/[äöüÄÖÜß]/g, (ch) => UMLAUTS[ch]);
  return out.normalize('NFD').replace(/[\u0300-\u036F]/g, '');
}

export function transliterate(s) {
  return foldToAscii(s).replace(/[^A-Za-z0-9]/g, '');
}

// Abgeleitetes Namensfeld für den Twin-Check (voices.translit_base). EXAKT die
// Formel, die computeUploadFilename bisher inline gebaut hat — eine Quelle für
// Query-Seite UND Backfill, damit die Spalte nie von der Vergleichslogik abweicht.
export function deriveTranslitBase(lastName, firstName) {
  return transliterate(lastName) + (firstName ? '_' + transliterate(firstName) : '');
}

// Optionaler Freitext-Suffix fürs Dateinamen-Ende: Umlaute/Akzente → ASCII,
// dann nur [A-Za-z0-9_+-] behalten, max 20 Zeichen. Leer → null.
export function sanitizeFreetextSuffix(s) {
  const cleaned = foldToAscii(s).replace(/[^A-Za-z0-9_+-]/g, '').slice(0, 20);
  return cleaned.length ? cleaned : null;
}

export function languageNamePart(code) {
  const c = String(code ?? '').trim();
  if (!c || c === 'de') return '';
  if (!(c in FILE_MARKERS)) throw new Error(`unknown_language_code:${c}`);
  return FILE_MARKERS[c] ?? '';
}

export function buildAudioFilename({ lastName, firstName, voiceId, language, dialect, accent, category, isDemomix, sequence, freetextSuffix }) {
  const parts = [];
  parts.push(transliterate(lastName));
  const first = firstName ? transliterate(firstName) : '';
  if (first) parts.push(first);
  parts.push(String(voiceId));
  const lang = languageNamePart(language);
  if (lang) parts.push(lang);
  if (dialect) parts.push('Dialect', dialect);
  if (accent) parts.push('Accent', accent);
  if (category) parts.push(category);
  if (isDemomix) parts.push('DemoMix');
  parts.push(String(sequence).padStart(2, '0'));
  if (freetextSuffix) parts.push(freetextSuffix);
  return parts.join('_') + '.mp3';
}
